'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineOverlay = require('./components/InlineOverlay.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineOverlay).default;
  }
});
Object.defineProperty(exports, 'InlineOverlay', {
  enumerable: true,
  get: function get() {
    return _InlineOverlay.InlineOverlay;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay/index.js
// module id = 1325
// module chunks = 1